import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectedStepService {
  selectedStepIndex = new BehaviorSubject<number | null>(null);

  constructor() {}

  selectStep(stepIndex: number) {
    this.selectedStepIndex.next(stepIndex);
  }

  deselectStep() {
    this.selectedStepIndex.next(null);
  }

  getSelectedStep() {
    return this.selectedStepIndex.getValue();
  }
}
